import React, { useContext } from "react";
import PropTypes from "prop-types";

import { ThemeAContext } from "../internal/ThemeAContext";
import { ThemeAProvider } from "./ThemeAProvider";

/**
 * Narrow coexistence boundary for a Theme A component rendered by a trained
 * V1 workflow. Existing V2 providers are preserved; legacy routes receive the
 * smallest possible local scope instead of silently weakening DS contracts.
 */
export function ThemeACompatibilityBoundary({ children, density = "comfortable" }) {
  const theme = useContext(ThemeAContext);
  if (theme) return children;
  return <ThemeAProvider density={density}>{children}</ThemeAProvider>;
}

ThemeACompatibilityBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  density: PropTypes.oneOf(["comfortable", "compact"]),
};
